/**
 * Normaliza valores leídos de localStorage (p. ej. id/jwt guardados con JSON.stringify
 * o con comillas envolventes) para enviarlos a la API como string limpio.
 */
export function storedStringValue(raw) {
    if (raw == null) return '';
    let s = String(raw).trim();
    for (let i = 0; i < 6; i++) {
        if (!s) return s;
        if (s.startsWith('"') && s.endsWith('"')) {
            try {
                const parsed = JSON.parse(s);
                if (typeof parsed === 'string') {
                    s = parsed.trim();
                    continue;
                }
            } catch (_) {
                /* seguir quitando comillas literales */
            }
            s = s.slice(1, -1).replace(/\\"/g, '"').trim();
            continue;
        }
        if (s.startsWith("'") && s.endsWith("'")) {
            s = s.slice(1, -1).trim();
            continue;
        }
        break;
    }
    return s;
}
